module.exports = __webpack_public_path__ + "static/media/ballot.1c20e9ba.svg";